export default __webpack_public_path__ + "static/media/CHRobinson.4c44fb0d.png";